<template>
	<span v-if="isDangerousGoods" class="badge-dangerous-goods position-relative">
		<img src="https://cdn.ostock.id/icons/warning.svg" v-tooltip="'Dangerous Goods'">
	</span>
</template>

<script>
export default {
	name: 'BadgeDangerousGoods',
	props: {
		isDangerousGoods: {
			type: Boolean,
			default: false,
		},
	},
};
</script>

<style scoped>
.badge-dangerous-goods img {
	width: 24px;
	height: 24px;
}
</style>
